/**
 * 微信相关信息
 * */

import {POST} from './service.config.js'

/**
 * 获取微信授权信息
 * @param code code message
 * @returns {*|Promise<unknown>}
 */
export const getWechatService = async code =>  await POST('btrexchange/wechatAuth',{
    code,
});


/**
 * 微信支付获取配置信息
 * @param openId 微信openID
 * @param shopId 商家ID
 * @param price 支付金额
 * @returns {*|Promise|Promise<unknown>}
 */
export const getWxPayService = (openId,shopId,price,tel,type) => POST('btrexchange/wxPay',{
    openid:openId,
    shop_id:shopId,
    amount: price,
    tel,
    type,
});



/**
 * 获取配置信息
 * @param url 用户ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getWxSharService = url => POST('btrexchange/getJsConfig',{url});







/**
 * 微信支付成功后下单
 * @param openId 用户微信ID
 * @param wxRecordId 支付表ID
 * @param shopId 商家ID
 * @param type 交易类型，0付款，1充值
 * @param price 交易金额
 * @param tel 用户手机号 非必填
 * @returns {*|Promise|Promise<unknown>}
 */
export const setDoOrder = (openId,wxRecordId,shopId,type,price,tel,uid) => POST('btrexchange/doOrder',{
    openid:openId,
    shop_id:shopId,
    wxRecordId:wxRecordId,
    type,
    amount:price,
    tel:tel,
    uid,
});

/**
 * 用户余额支付
 * @param tel 用户电话号
 * @param shopId 商家ID
 * @param price 支付金额
 * @returns {*|Promise|Promise<unknown>}
 */
export const balancePayService = (tel,shopId,price) => POST('btrexchange/balancePay',{
    tel:tel,
    shop_id:shopId,
    amount:price,
});